var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowCheckTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#D5D8DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 10.4004C22.5465 10.4004 24.9883 11.4118 26.7886 13.2122C28.589 15.0125 29.6004 17.4543 29.6004 20.0004C29.6004 22.5465 28.589 24.9883 26.7886 26.7886C24.9883 28.589 22.5465 29.6004 20.0004 29.6004C17.4543 29.6004 15.0125 28.589 13.2122 26.7886C11.4118 24.9883 10.4004 22.5465 10.4004 20.0004C10.4004 17.4543 11.4118 15.0125 13.2122 13.2122C15.0125 11.4118 17.4543 10.4004 20.0004 10.4004ZM24.03 17.1756C23.9306 17.0767 23.7998 17.0157 23.6602 17.0032C23.5205 16.9907 23.3809 17.0275 23.2656 17.1072L23.1816 17.1756L18.8004 21.558L16.8252 19.5816L16.7412 19.512C16.6256 19.4324 16.4858 19.3958 16.346 19.4086C16.2063 19.4214 16.0754 19.4828 15.9762 19.5821C15.8771 19.6814 15.8158 19.8124 15.8032 19.9522C15.7906 20.0919 15.8274 20.2317 15.9072 20.3472L15.9756 20.4312L18.3756 22.8312L18.4596 22.8996C18.5598 22.9687 18.6786 23.0058 18.8004 23.0058C18.9221 23.0058 19.041 22.9687 19.1412 22.8996L19.2252 22.83L24.03 18.0252L24.0996 17.9412C24.1795 17.8256 24.2162 17.6857 24.2035 17.5458C24.1908 17.4059 24.1294 17.2749 24.03 17.1756Z",
    fill: "#F1D071"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCheckTimeline);
export default __webpack_public_path__ + "static/media/yellow_check_timeline.1536b887ec3d91b0ad04e65446071e77.svg";
export { ForwardRef as ReactComponent };